import { ConvertableTokenSymbolConfig } from "types";

export const CONVERTABLE_TOKEN_SYMBOLS: ConvertableTokenSymbolConfig = {
  wbnb: 'BNB',
  weth: 'ETH',
}
